/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from "react"
import Upload from "./Upload"
import Grid from "@mui/material/Grid"
import List from "@mui/material/List"
import ListItemText from "@mui/material/ListItemText"
import Paper from "@mui/material/Paper"
import CircularProgress from "@mui/material/CircularProgress"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import ListItemButton from "@mui/material/ListItemButton"
import { withStyles } from "@mui/styles"
import SerialNumberSearch from "./SerialNumberSearch"
import ProductClassification from "./ProductClassification"
import { bindActionCreators } from "redux"
import { actionCreators } from "../store/ViewManual"
import { connect } from "react-redux"
import { getHelpButtons, getServiceManualTypes, isRoleExists} from "../common/common"
import EditManual from "./EditManual"


// removed unused classNames require
const styles = () => ({  
  selectInput: {
    backgroundColor: "#fff",
    borderRadius: 0,
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        height: 40,
        "& .MuiSelect-select": {
            padding: "10px 32px 10px 12px"
        },
    "& em": {
      fontSize: 14,
      fontStyle: "normal"
    }
  },
  dropdown: {
    fontSize: 14,
    fontStyle: "normal",
    marginLeft: 10
  }
})

interface Props {
    serviceManualData: any
    classes?: any
    selectedFamily: any,
    selectedProductName: any
    selectedProductModel: any
    isLoading: any
    loadingManualDetail: any
    isMenuExpanded: boolean
    serialNumber: any
    selectedManual: any
    families: any
    productModels: any
    productNames: any

    selectManual: Function
    UpdateSelectedFamily: Function,
    UpdateSelectedProductName: Function
    UpdateSelectedProductModel: Function
    UpdateProductFamilies: Function
    FilterNames: Function,
    FilterModels: Function,
    UpdateProductClassificationonSerialNumber: Function
    LoadServiceManual: Function
    UpdateSerialNumber: Function
    StopLoading: Function,
    ClearViewManualData: Function,
    ClearManualList:Function
}
interface State {
  selectedPage: any
  selectedManualPageNumAppendedUrl: any
}
const ProductFamily = "selectedFamily"
const ProductName = "selectedProductName"
const ProductModel = "selectedProductModel"

class ServiceManual extends React.Component<Props, State>{

    state = {
        selectedPage: 0,
        selectedManualPageNumAppendedUrl: '#page=1',
    }
    selectManualItemClick = (data: any, id: any) => async (event: any) => {
        this.setState({
            selectedPage: 0,
            selectedManualPageNumAppendedUrl: '#page=1',
        }, () => {
            this.props.selectManual(data)
        })
    }
    handleHelpButtonChange = (selectedHelpButtons: any) => (event: any) => {
        if (selectedHelpButtons !== undefined) {
            const selectedpage = selectedHelpButtons.find((y: any) => { return y.helpButtonTypeid === event.target.value });
            if (selectedpage !== undefined) {
                this.setState({ selectedManualPageNumAppendedUrl: '' }, () => {
                    this.setState({ selectedPage: event.target.value, selectedManualPageNumAppendedUrl: '#page=' + selectedpage.pageNumber })
                });

            }

        }
    }
    renderLeft = (data: any, classes: any, id: any, serviceManualTypes: any) => {
        const n = (data.displayName != null && data.displayName != undefined) ? data.displayName.split('.')[0] : '';
        const typename = (serviceManualTypes && serviceManualTypes.length) ? (this.serviceManualTypes.find((x: any) => { return x.id == data.serviceManualTypeId })) : ''
        console.log(typename);
        return (
            <Paper className="manualPaper" elevation={0} key={data[id]}>
                <ListItemButton key={data[id]} onClick={this.selectManualItemClick(data, id)} selected={this.props.selectedManual && data[id] == this.props.selectedManual[id]}
                    className={(this.props.selectedManual && data[id] == this.props.selectedManual[id]) ? "selectedManual" : ""}
                    style={{ paddingTop: 12, paddingBottom: 12 }}>
                    <ListItemText>
                        <Grid container justifyContent="space-between" className="font14">
                            <div className="headerLeft trimText">
                                {n}
                            </div>
                            <div className="font10 modelName">
                                {typename != null && typename != undefined && typename.name}
                            </div>
                        </Grid>
                        <Grid container justifyContent="space-between" className="font10">
                            <div className="headerLeft">
                                {data.fileName}
                            </div>
                            {data.dateOfIssue && <div>
                                {new Date(data.dateOfIssue + "Z").toLocaleDateString(undefined, { month: 'short', year: 'numeric' })}
                            </div>}
                        </Grid>
                    </ListItemText>
                </ListItemButton>
            </Paper>
        )
    }
    handleManualClassificationChange = (event: any) => {
        if (event.target.value != ''){
            switch (event.target.name) {
                case ProductFamily:
                    this.props.UpdateSelectedFamily([event.target.value])
                    this.props.FilterNames(this.props.families, [event.target.value])
                    break;
                case ProductName:
                    this.props.UpdateSelectedProductName([event.target.value])
                    this.props.FilterModels(this.props.productNames, [event.target.value])
                    break;
                case ProductModel:
                    this.props.UpdateSelectedProductModel([event.target.value])
                    break;
            }
         }
    }
    handleSerialNumberSearch = async (twoDproductFamilyid: any, twoDproductNameid: any, twodModelid: any, serviceManuals: any) => {
        await this.props.FilterNames(this.props.families, twoDproductFamilyid);
        await this.props.FilterModels(this.props.productNames, twoDproductNameid);
        await this.props.UpdateProductClassificationonSerialNumber(twoDproductFamilyid,
            twoDproductNameid,
            twodModelid,
            serviceManuals)
    }
    UpdateProductFamilies = (data: any) => {
        this.props.UpdateProductFamilies(data);
    }
    helpButtons: any
    serviceManualTypes: any
    async componentDidMount() {
        this.props.ClearViewManualData();
        this.helpButtons = [{ helpbuttonid: 0, description: "First Page", pageNumber: 1 }].concat(await getHelpButtons());
        this.serviceManualTypes = await getServiceManualTypes()
    }
    LoadServiceManual = (data: any) => {
        this.props.LoadServiceManual(data)
    }
    UpdateSerialNumber = (data: any) => {
        this.props.UpdateSerialNumber(data)
    }
    StopLoading = () => {
        this.props.StopLoading()
    }
    ClearAll = () => {
        this.props.ClearManualList();
    }
    render() {
        const { classes, serviceManualData, selectedFamily, selectedProductName, selectedProductModel, isLoading, selectedManual, loadingManualDetail, serialNumber } = this.props
        let selectedhelpButtons: any = [{ helpButtonTypeid: 0, description: "First Page", pageNumber: 1 ,sortOrder: 0}], serviceManualType: any = undefined
        
        if (selectedManual != undefined) {
            if (selectedManual.helpButtons != undefined){
                selectedhelpButtons = selectedhelpButtons.concat(selectedManual.helpButtons)
            }
            selectedhelpButtons.sort((a: any, b: any) => (a.sortOrder > b.sortOrder) ? 1 : -1);
            if (this.serviceManualTypes && this.serviceManualTypes.length){
                serviceManualType = this.serviceManualTypes.find((x: any) => { return x.id == selectedManual.serviceManualTypeId })
            }
        }
        const isMenuExpanded = this.props.isMenuExpanded
        return (
            <Grid className="viewManualGrid">

        <Grid container justifyContent="space-between">
                    <SerialNumberSearch isBulletin={false} isDownloads={false} isLaborTimeGuide={false} isInstrumentConstants={false} handleSerialNumberSearch={this.handleSerialNumberSearch} LoadServiceManual={this.LoadServiceManual} UpdateSerialNumber={this.UpdateSerialNumber} StopLoading={this.StopLoading}
                    selectedFamily={this.props.selectedFamily} selectedProductName={this.props.selectedProductName} selectedProductModel={this.props.selectedProductModel} productModels={this.props.productModels} families={this.props.families} productNames={this.props.productNames} isLoading={this.props.isLoading} serialNumber={this.props.serialNumber} ClearAll={this.ClearAll} />
                or
            <ProductClassification families={this.props.families} selectedFamily={this.props.selectedFamily} selectedProductName={this.props.selectedProductName} selectedProductModel={this.props.selectedProductModel}
                    productModels={this.props.productModels} productNames={this.props.productNames} handleManualClassificationChange={this.handleManualClassificationChange} isLoading={this.props.isLoading}
                    UpdateProductFamilies={this.UpdateProductFamilies} /><div>
                    {isRoleExists(4) && <Upload />}</div>
            
        </Grid>
        <Grid container justifyContent="space-between" className="viewManualListPDF">
          <Grid className={isMenuExpanded ? 'viewManualLeftExpanded' : 'viewManualLeft'}>
            {
              (selectedFamily || selectedProductName || selectedProductModel || serialNumber) ?

                                (isLoading ?
                                    <div className="leftInitial">
                                        <CircularProgress color="secondary" />
                                    </div> :
                                    (serviceManualData && serviceManualData.length ?
                                        <div>
                                            <div className="resultsHeader font14 boldFont">Results</div>
                                            <List component="nav" className={classes.rootList}>
                                                {serviceManualData.map((x: any) => {
                                                    return this.renderLeft(x, classes, 'serviceManualId', this.serviceManualTypes)
                                                })
                                                }
                                            </List>
                                        </div>
                                        :
                                        <div className="leftInitial">No Data for the selected filter</div>)
                                )
                                :
                                <div className="leftInitial">Apply filter to populate this list</div>
                        }
                    </Grid>
                    <div className="divider"></div>
                    <Grid className={isMenuExpanded ? 'rightExpanded' : 'right'}>
                        {loadingManualDetail ?
                            <div className="rightInitial">
                                <CircularProgress color="secondary" />
                            </div>
                            :
                            <div>
                                {selectedManual !== undefined ?
                                    <div>
                                        <Grid>
                                            <Grid container justifyContent="space-between" className="serviceManualDetailWidth" style={{ marginTop: 12 }}>
                                                <div className="serviceManualRightContents font14">
                                                    {isRoleExists(4) && <EditManual />}
                                                </div>
                                                <div className="serviceManualRightContents font14"> {(selectedManual.displayName == null || selectedManual.displayName == undefined) ? '' : selectedManual.displayName.split('.')[0]}</div>
                                                <div className="serviceManualRightContents font14">{(selectedManual.serviceManualPartnumber === null || selectedManual.serviceManualPartnumber === undefined) ? '' : selectedManual.serviceManualPartnumber}</div>
                                                <div className="serviceManualRightContents font14">{serviceManualType != null && serviceManualType != undefined && serviceManualType.name}</div>
                                                <div className="serviceManualRightContents font14">
                                                    {
                                                        'Rev ' + ((selectedManual.revision == null || selectedManual.revision == undefined) ? '' : selectedManual.revision) +
                                                            ((selectedManual.dateOfIssue != null && selectedManual.dateOfIssue != undefined) ?
                                                            (', ' + new Date(selectedManual.dateOfIssue + "Z").toLocaleDateString(undefined, { month: 'short', year: 'numeric' })) : '')
                                                    }
                                                </div>
                                                <div>
                                                    <Select
                                                        id="demo-simple-select-outlined"
                                                        style={{ width: 180 }}
                                                        value={this.state.selectedPage}
                                                        onChange={this.handleHelpButtonChange(selectedhelpButtons)}
                                                        classes={{ root: classes.selectInput }}
                                                    >
                                                        {selectedhelpButtons.map((x: any) => {
                                                                    return <MenuItem key={x.pageNumber} value={x.helpButtonTypeid} style={{ paddingTop: 10, paddingBottom: 10, marginBottom: 4 }}>
                                                                    <em className={classes.dropdown}>{this.helpButtons !== undefined &&
                                                                        this.helpButtons.find((y: any) => { return y.helpbuttonid == x.helpButtonTypeid }) != undefined ?

                                                                        this.helpButtons !== undefined && this.helpButtons.find((y: any) => { return y.helpbuttonid == x.helpButtonTypeid }).description : x.helpButtonTypeid}</em>
                                                                </MenuItem>
                                                        })}
                                                    </Select>
                                                </div>
                                            </Grid>

                                        </Grid>
                                        <Grid className="pdfContainer pdfContainerWithData">
                                            {this.state.selectedManualPageNumAppendedUrl !== '' && selectedManual !== undefined &&
                                                <object data={selectedManual.presignedURL + this.state.selectedManualPageNumAppendedUrl} type="application/pdf" className="viewManualPDf" >
                                                    <embed src={selectedManual.presignedURL + this.state.selectedManualPageNumAppendedUrl} type="application/pdf" />
                                                </object>
                                            }
                                        </Grid>
                                    </div>
                                    :
                                    <div className="pdfContainer">
                                        <p>Select a document from the list</p>
                                    </div>
                                }
                            </div>
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = (state: any) => ({
    state: state.viewManual,
    data: state.viewManual.data,
    serviceManualData: state.viewManual.serviceManualData,
    selectedFamily: state.viewManual.selectedFamily,
    selectedProductName: state.viewManual.selectedProductName,
    selectedProductModel: state.viewManual.selectedProductModel,
    isLoading: state.viewManual.isManualLoading,
    loadingManualDetail: state.viewManual.loadingManualDetail,
    selectedManual: state.viewManual.selectedManual,
    isMenuExpanded: state.navMenu.isMenuExpanded,
    serialNumber: state.viewManual.serialNumber,
    families: state.viewManual.families,
    productModels: state.viewManual.productModels,
    productNames: state.viewManual.productNames,
});

const mapDispatchtoProps = (dispatch: any) =>
  bindActionCreators(actionCreators, dispatch);

const StyledServiceManual: any = withStyles(styles)(ServiceManual);
export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(StyledServiceManual as any);